import { defineMessages } from "react-intl";

export default defineMessages({
  "verification.phoneNumberVerification.code_resent": {
    id: "verification.phoneNumberVerification.code_resent",
    defaultMessage: "Code sent again! Check your SMS.",
  },
  "verification.phoneNumberVerification.code_title": {
    id: "verification.phoneNumberVerification.code_title",
    defaultMessage: "Verify your phone number",
  },
  "verification.phoneNumberVerification.contact_support": {
    id: "verification.phoneNumberVerification.contact_support",
    defaultMessage: "Please contact support",
  },
  "verification.phoneNumberVerification.max_attempts_message": {
    id: "verification.phoneNumberVerification.max_attempts_message",
    defaultMessage: "You have reached your maximum number of attempts.",
  },
  "verification.phoneNumberVerification.next_try": {
    id: "verification.phoneNumberVerification.next_try",
    defaultMessage: "Next try: {time}",
  },
  "verification.phoneNumberVerification.phone_code_description": {
    id: "verification.phoneNumberVerification.phone_code_description",
    defaultMessage:
      "Enter the 4-digit code sent to your phone to verify your number. Valid for 1 minute.",
  },
  "verification.phoneNumberVerification.phone_input_description": {
    id: "verification.phoneNumberVerification.phone_input_description",
    defaultMessage:
      "Your number remains private on Ring Twice. The client will get it once they've chosen you for the job.",
  },
  "verification.phoneNumberVerification.phone_number_label": {
    id: "verification.phoneNumberVerification.phone_number_label",
    defaultMessage: "Phone number",
  },
  "verification.phoneNumberVerification.resend_code": {
    id: "verification.phoneNumberVerification.resend_code",
    defaultMessage: "Resend code",
  },
  "verification.phoneNumberVerification.resend_prompt": {
    id: "verification.phoneNumberVerification.resend_prompt",
    defaultMessage: "Didn't receive the code?",
  },
  "verification.phoneNumberVerification.success_toast": {
    id: "verification.phoneNumberVerification.success_toast",
    defaultMessage: "Verification successful!",
  },
  "verification.phoneNumberVerification.title": {
    id: "verification.phoneNumberVerification.title",
    defaultMessage: "Verify Your Phone Number",
  },
  "verification.phoneNumberVerification.verify": {
    id: "verification.phoneNumberVerification.verify",
    defaultMessage: "Verify",
  },
  "verification.phoneNumberVerification.verify_number": {
    id: "verification.phoneNumberVerification.verify_number",
    defaultMessage: "Verify my number",
  },
  "verification.phoneNumberVerification.wrong_code": {
    id: "verification.phoneNumberVerification.wrong_code",
    defaultMessage: "Incorrect code. Please try again.",
  },
  "verification.phoneNumberVerification.invalid_phone_number": {
    id: "verification.phoneNumberVerification.invalid_phone_number",
    defaultMessage: "This phone number is not valid. Check your phone number and try again.",
  },
  "verification.phoneNumberVerification.phone_not_allowed": {
    id: "verification.phoneNumberVerification.phone_not_allowed",
    defaultMessage: "This phone number is not allowed.",
  },
  "verification.phoneNumberVerification.sms_region_not_supported": {
    id: "verification.phoneNumberVerification.sms_region_not_supported",
    defaultMessage: "SMS verification isn't available for this country.",
  },
  "verification.phoneNumberVerification.sms_not_a_mobile_number": {
    id: "verification.phoneNumberVerification.sms_not_a_mobile_number",
    defaultMessage: "This isn't a mobile number. Please enter a mobile number.",
  },
  "verification.phoneNumberVerification.sms_opted_out": {
    id: "verification.phoneNumberVerification.sms_opted_out",
    defaultMessage: "We can't send SMS to this number.",
  },
  "verification.phoneNumberVerification.sms_delivery_failed": {
    id: "verification.phoneNumberVerification.sms_delivery_failed",
    defaultMessage: "We couldn't send the SMS. Please try again.",
  },
});
